import * as React from 'react';

import { useState, useEffect, Fragment } from 'react';
import { useParams } from 'react-router-dom';
import StepOneIntro from './StepOneIntro';
import StepTwoName from './StepTwoName';
import StepThreeAddress from './StepThreeAddress';
import { supabase } from '../../../api';

import { Paper, Box, Grid } from '@mui/material';
import Stepper from '@mui/material/Stepper';
import MobileStepper from '@mui/material/MobileStepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import StepFourLinkedinSkills from './StepFourLinkedinSkills';
import StepFiveCompany from './StepFiveCompany';
import StepSixCompanyLink from './StepSixCompanyLink';
import StepSevenCompanySize from './StepSevenCompanySize';
import StepEightCompanyAbout from './StepEightCompanyAbout';
import StepElevenTransition2 from './StepElevenTransition2';
import StepTwelveBreakIce1 from './StepTwelveBreakIce1';
import StepThirteenBreakIce2 from './StepThirteenBreakIce2';
import StepFourteenJoin from './StepFourteenJoin';
import './GlobalCssProgressBar.css';
import { StyledEngineProvider } from '@mui/material';

import { PROFILE_TABLE } from '../../../constants/supabase_constants';

const steps = [
  'Welcome',
  'Name',
  'Linkedin',
  'Company Name',
  'Company Link',
  'Revenue',
  'About Company',
  'Headquarters',
  'Break the ice 1',
  'Break the ice 2',
  'Address',
  'Join Telegram!',
];

export default function HorizontalLinearStepper({ session, membershipLevel }) {
  const [loading, setLoading] = useState(true);
  const [activeStep, setActiveStep] = useState(0);

  useEffect(() => {
    getProfile();
    // eslint-disable-next-line
  }, []);

  let { id } = useParams();

  const getProfile = async () => {
    try {
      setLoading(true);
      let { data, error, status } = await supabase.from(PROFILE_TABLE).select(`onboardingStep`).eq('id', id).single();

      if (data) {
        setActiveStep(data.onboardingStep ? data.onboardingStep : 0);
      }

      if (error && status !== 406) {
        throw error;
      }
    } catch (error) {
      alert(error.message);
    } finally {
      setLoading(false);
    }
  };

  const updateProfile = async () => {
    try {
      const updates = {
        id: id,
        onboardingStep: activeStep,
        updated_at: new Date(),
      };

      let { error } = await supabase.from(PROFILE_TABLE).upsert(updates, {
        returning: 'minimal', // Don't return the value after inserting
      });

      if (error) {
        throw error;
      }
    } catch (error) {
      alert(error.message);
    }
  };

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
    updateProfile();
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const content = () => {
    switch (activeStep) {
      case 0:
        return <StepOneIntro activeStep={activeStep} handleBack={handleBack} handleNext={handleNext} steps={steps} />;
      case 1:
        return <StepTwoName activeStep={activeStep} handleBack={handleBack} handleNext={handleNext} steps={steps} />;
      case 2:
        return (
          <StepFourLinkedinSkills
            activeStep={activeStep}
            handleBack={handleBack}
            handleNext={handleNext}
            steps={steps}
          />
        );
      case 3:
        return (
          <StepFiveCompany activeStep={activeStep} handleBack={handleBack} handleNext={handleNext} steps={steps} />
        );
      case 4:
        return (
          <StepSixCompanyLink activeStep={activeStep} handleBack={handleBack} handleNext={handleNext} steps={steps} />
        );
      case 5:
        return (
          <StepSevenCompanySize activeStep={activeStep} handleBack={handleBack} handleNext={handleNext} steps={steps} />
        );
      case 6:
        return (
          <StepEightCompanyAbout
            activeStep={activeStep}
            handleBack={handleBack}
            handleNext={handleNext}
            steps={steps}
          />
        );
      case 7:
        return (
          <StepElevenTransition2
            activeStep={activeStep}
            handleBack={handleBack}
            handleNext={handleNext}
            steps={steps}
          />
        );
      case 8:
        return (
          <StepTwelveBreakIce1 activeStep={activeStep} handleBack={handleBack} handleNext={handleNext} steps={steps} />
        );
      case 9:
        return (
          <StepThirteenBreakIce2
            activeStep={activeStep}
            handleBack={handleBack}
            handleNext={handleNext}
            steps={steps}
          />
        );
      case 10:
        return (
          <StepThreeAddress activeStep={activeStep} handleBack={handleBack} handleNext={handleNext} steps={steps} />
        );
      default:
        return (
          <StepFourteenJoin activeStep={activeStep} handleBack={handleBack} handleNext={handleNext} steps={steps} />
        );
    }
  };

  return (
    <Fragment>
      {loading ? (
        'Loading ...'
      ) : (
        <Grid display='flex' direction='column' alignItems='center' justifyContent='center'>
          <Paper
            elevation={20}
            sx={{
              mt: '2rem',
              textAlign: 'left',
              width: { lg: 'min(900px, 60vw)' },
              position: 'relative',
              borderRadius: 5,
            }}>
            <Paper
              sx={{
                padding: '2rem',
                borderRadius: 5,
              }}>
              <Stepper activeStep={activeStep} alternativeLabel sx={{ display: { xs: 'none', md: 'flex' } }}>
                {steps.map((label, index) => {
                  const stepProps = {};
                  const labelProps = {};
                  return (
                    <Step key={label} {...stepProps}>
                      <StepLabel {...labelProps}></StepLabel>
                    </Step>
                  );
                })}
              </Stepper>
              <StyledEngineProvider injectFirst>
                <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                  <MobileStepper
                    variant='progress'
                    steps={12}
                    position='static'
                    activeStep={activeStep}
                    sx={{
                      flexGrow: 1,
                      display: { md: 'none' },
                      marginX: 'auto',
                      width: '100%',
                    }}
                  />
                </Box>
              </StyledEngineProvider>
              <Box
                sx={{
                  margin: 'auto',
                  width: { md: activeStep === 8 ? '100%' : 'min(600px, 40vw)' },
                }}>
                {content()}
              </Box>
            </Paper>
          </Paper>
        </Grid>
      )}
    </Fragment>
  );
}
